<div class="banner-container" [ngClass]="{'success-container' : isSuccess, 'error-container' : !isSuccess }">
  <mat-icon *ngIf="isSuccess" class="success-icon">check_circle</mat-icon>
  <mat-icon *ngIf="!isSuccess" class="error-icon">error</mat-icon>
  <span class="text-description">
    <p 
      [ngClass]="{ 'remove-bottom-margin': isDescriptionEmpty }"
      class="header iris-button-text" 
      data-test="banner-title"
    >
      {{ message?.title }}
    </p>
    <p *ngIf="!isDescriptionEmpty" class="remove-bottom-margin" data-test="banner-description">{{ message?.description }}</p>
  </span>
</div>
